import { Box, Container, Flex, Grid, Heading, Text } from '@chakra-ui/react';
import { ButtonFullWidthMobile } from '@components/Button';
import {
  AccordionItemContent,
  AccordionItemTrigger,
  AppLink,
  Badge,
  Image,
  LANDING_ROUTES,
  pxToRem,
} from '@cyberkongz/ui';

import { CARDS_ECOSYSTEM } from './content/cards';
import {
  ActiveCardSidebar,
  CardItemWrapper,
  CardsSectionWrapper,
  IntroSectionWrapper,
  introTextStyles,
  ListOfPartnerships,
  useCardsSection,
} from './Shared';

function IntroSection() {
  return (
    <IntroSectionWrapper
      sxSection={{
        backgroundImage: 'url(/static/blueprint/ecosystem/intro_bg.jpg)',
      }}
      stylesContainer={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box css={{ maxWidth: ['100%', '62%'], position: 'relative', zIndex: 1 }}>
        <Heading mb={2}>
          our driving
          <Heading
            as="span"
            variant="displaySecondary"
            css={{
              position: 'relative',
              top: '0.07em',
              ml: [3, 6],
            }}
          >
            force
          </Heading>
        </Heading>
        <Text css={{ ...introTextStyles, mb: 8 }}>
          On the surface, we are an OG PFP project, one of the first popularized profile pictures of
          the 2D social world. Behind the scenes, there is a beautifully complex and growing
          ecosystem that continues to explore and innovate in Web3.
        </Text>
        <ButtonFullWidthMobile href={LANDING_ROUTES.ABOUT}>about us</ButtonFullWidthMobile>
      </Box>
    </IntroSectionWrapper>
  );
}

function CardsSection() {
  const { activeItem, handleChange } = useCardsSection();
  const activeCardSidebar = activeItem ? (
    <ActiveCardSidebar {...CARDS_ECOSYSTEM[parseInt(activeItem)]} basePath="ecosystem" />
  ) : null;

  return (
    <CardsSectionWrapper
      {...{
        activeItem,
        handleChange,
        activeCardSidebar,
      }}
    >
      {CARDS_ECOSYSTEM.map(({ title, description, badgeColor, badgeLabel, href }, i) => (
        <CardItemWrapper key={i} value={i}>
          <AccordionItemTrigger>
            <Flex css={{ justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
              <Badge badgeColor={badgeColor} withDot>
                {badgeLabel}
              </Badge>
            </Flex>
          </AccordionItemTrigger>
          {href ? (
            <AppLink href={href}>
              <Heading size="2xs" css={{ mt: [4, 5], color: 'text' }}>
                {title}
              </Heading>
            </AppLink>
          ) : (
            <Heading size="2xs" css={{ mt: [4, 5], color: 'text' }}>
              {title}
            </Heading>
          )}
          <AccordionItemContent>
            <Box color="textSecondary">{description}</Box>
            <Box display={['block', 'none']}>{activeCardSidebar}</Box>
          </AccordionItemContent>
        </CardItemWrapper>
      ))}
    </CardsSectionWrapper>
  );
}

// TO DO EXTRACT IMAGES GRID AS REUSABLE WRAPPER
const IMAGES = ['evaverse', 'habbo', 'sandbox', 'metaresidence', 'peppo', 'metakey', 'arcade'];

function ProjectPartnerships() {
  return (
    <Box pt={pxToRem(128)}>
      <Container>
        <Flex css={{ alignItems: 'center' }}>
          <Heading size="sm" mr={4}>
            Project Partnerships
          </Heading>
          <Badge badgeColor="primary" withDot>
            Ongoing
          </Badge>
        </Flex>
        <Box css={{ color: 'textSecondary', maxW: '62em', mt: 4 }}>
          Staying true to our vision for interoperability, we have and will continue engaging in
          cross project partnerships with like-minded projects that are pushing this space forward!
        </Box>
        <Grid
          css={{
            gap: [3, 4, 6],
            mt: 10,
            gridTemplateColumns: ['repeat(2, 1fr)', 'repeat(4, 1fr)'],
          }}
        >
          {IMAGES.map((image) => (
            <Image
              key={image}
              src={`/static/blueprint/ecosystem/thumbnail_${image}.png`}
              alt={image}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export function EcosystemTab() {
  return (
    <>
      <IntroSection />
      <CardsSection />
      <ProjectPartnerships />
      <ListOfPartnerships />
    </>
  );
}
